// extracted by mini-css-extract-plugin
export default {"folderTagsContainer":"TaggedFolders__folderTagsContainer___eZnMZ","folderTag":"TaggedFolders__folderTag___CG2hl"};